<mat-chip-listbox #chipList aria-label="Tags">
  @for (tag of selectedTags; track tag) {
    <mat-chip-option (removed)="remove(tag)">
      {{ tag.text }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip-option>
  }
  <div class="tag-list-add">
    @if (tags && tags.length > 0) {
      <button type="button" class="btn-icon btn-add-small blue" [matMenuTriggerFor]="menu">
        <mat-icon svgIcon="add-small"></mat-icon>
        <span>Tilføj tag</span>
      </button>
    }
  </div>
  <mat-menu #menu="matMenu">
    @for (tag of tags; track tag) {
      <button (click)="add(tag.id)" mat-menu-item class="chips">{{ tag.text }}</button>
    }
  </mat-menu>
</mat-chip-listbox>
